import Header from '../components/Header';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import StructuredData from '../components/StructuredData';
import GoogleAnalytics from '../components/GoogleAnalytics';
import MetaPixel from '../components/MetaPixel';
import CookieConsent from '../components/CookieConsent';
import CanonicalUrl from '../components/CanonicalUrl';
import MotionEffects from '../components/MotionEffects';
import Seo from '../components/Seo';
import { useConsent } from '../utils/consent';

const DEFAULT_TITLE = 'Psiholog Novi Sad | Clarity - Psihološko Savetovalište';
const DEFAULT_DESCRIPTION =
  'Psiholog Novi Sad - Centar Clarity. Profesionalna psihološka pomoć u Novom Sadu. Psihoterapija, savetovanje, testiranje i podrška za pojedince i kompanije. Zakazivanje termina.';

export default function Layout({ children, title, description }) {
  const consent = useConsent();
  const consentGranted = consent === 'granted';

  return (
    <>
      <Seo title={title || DEFAULT_TITLE} description={description || DEFAULT_DESCRIPTION} />
      <CanonicalUrl />
      <GoogleAnalytics consentGranted={consentGranted} />
      <MetaPixel consentGranted={consentGranted} />
      <StructuredData />
      <ScrollToTop />
      <Header />
      <main className="page-content">{children}</main>
      <Footer />
      <CookieConsent />
      <MotionEffects />
    </>
  );
}
